import React from 'react';
import { YEAR_MONTH_DAY_FORMAT } from '../../global/enums/dateFormat';
import { formatDate } from 'utils/DateUtil';

export const renderDayPickerDayWithDataCy = (day, dataCyPrefix) => {
    const date = day.getDate();
    const prefix = dataCyPrefix ? `${dataCyPrefix}-` : '';
    return <div data-cy={`${prefix}[${formatDate(day, YEAR_MONTH_DAY_FORMAT)}]`}>{date}</div>;
};
